<div class="bg-white rounded mb-3">
  <div class="border-bottom border-2">
    <div class="px-4">
      <h3 class="pt-2">Make Adjustment</h3>
    </div>
  </div>
  <form *ngIf="makeAdjustmentForm" [formGroup]="makeAdjustmentForm" (submit)="onSubmit()">
    <div class="p-4">
      <div class="form-group row">
        <div class="col-12 col-sm-6 mb-3">
          <label>Description</label>
          <input type="text" class="form-control" placeholder="Description" formControlName="description" />
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label>Amount <span class="text-danger">*</span></label>
          <input type="number" placeholder="Amount" formControlName="amount" class="form-control" min="1"/>
          <small class="login-error login-error-hidden"
                 [ngClass]="{
            'login-error-visible': formValidator.formErrors.amount,
            'login-error-hidden': '!formValidator.formErrors.amount'}">
            {{ formValidator?.formErrors?.amount ? formValidator.formErrors.amount : "" }}
          </small>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label>Type <span class="text-danger">*</span></label>
          <select placeholder="Type" formControlName="type" class="form-control">
            <option selected disabled value="null">Type</option>
            <option *ngFor="let type of types" [value]="type.id">
              {{ type.name }}
            </option>
          </select>
        </div>
        <div class="col-12 col-sm-6 mb-3" *ngIf="bussineses">
          <label>Select a Domain <span class="text-danger">*</span></label>
          <app-select-box-search [placeholder]="'select bussines ..'" [list]='bussineses' [searchKey]="'name'"
                                 [defaultValue]="defaultValue" (valueChange)="displaySeller($event)">
          </app-select-box-search>
        </div>
      </div>
      <button class="btn btn-primary" type="submit" [disabled]="makeAdjustmentForm?.invalid">
        Submit
      </button>
    </div>
  </form>
</div>
